import Stack from 'atoms/Layout/Stack/Stack';
import styled from 'styled-components';

export const VerticalContentCardWrapper = styled(Stack)`
  .vertical-content-card-item {
    height: 100%;
    width: 100%;
  }
`;
